// Status tab: workspace-scoped — surfaces the repos this workspace
// is connected to plus per-repo health (default branch, latest CI
// signal). Captain canon 2026-04-26: every tab inside a Workspace is
// diegetic to that Workspace. The Waytide infra status board lives at
// the public /status page, not in here.

import { TabScrollbox } from "../../chrome/TabScrollbox";
import { ConnectedReposPanel } from "../ConnectedReposPanel";
import { MemoryIntegrityPanel } from "../MemoryIntegrityPanel";

interface Props {
  workspaceId: number;
}

export function StatusTab({ workspaceId }: Props) {
  return (
    <TabScrollbox>
      <div className="flex w-full flex-col gap-4">
        <header>
          <p className="text-xs text-muted">
            The repos this workspace is connected to and the integrity
            of its workspace memory. Connect GitHub to authorise the
            account, then attach as many repos as the workspace builds
            against.
          </p>
        </header>
        <ConnectedReposPanel workspaceId={workspaceId} />
        <MemoryIntegrityPanel />
      </div>
    </TabScrollbox>
  );
}
